import { DatePipe, formatDate } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { ConfirmationService, MessageService } from 'primeng/api';
import {  ContractForecastAttachments, ForecastAttachments } from 'src/app/Finance/Models/contract-forecast';
import { FinanceService } from 'src/app/Finance/Services/invoice.service';
import { LoaderService } from 'src/app/Loader/loader.service';
import { SponserService } from 'src/app/MasterData/Services/sponser.service';

import { AuditIdentifier, AuditLogEntities, AuditLogModule, AuditOperations, Dateformat, FileExtension } from 'src/app/shared/constants/global.constants';
import { AuditLogService } from 'src/app/shared/ModelComparison/audit.log.service';
import { PrivilegeService } from 'src/app/Reusable/privilege.service';
import { FileUploadService } from 'src/app/Engagement/Services/fileupload.service';
import { TabAndStateService } from 'src/app/shared/TabAndStateService/TabAndState.Service';

@Component({
  selector: 'app-con-forecast-edit',
  templateUrl: './con-forecast-edit.component.html',
  styleUrls: ['./con-forecast-edit.component.css']
})
export class ConForecastEditComponent {
  

  @Output() cancelForecastButtonClick = new EventEmitter<void>();
  @Output() saveForecastButtonClick = new EventEmitter<void>();
  @Output() viewButtonClick: EventEmitter<any> = new EventEmitter<any>();

  @Input() contractId: any;
  @Input() forecastId: any;
  forecastDetail:any;
  forecastDetailOld:any;
  forecastSubmitted:Boolean=false;
  isSaveBtnDisable = false;
  _dateformart :any;
  forecastForm: FormGroup;
  currentIndex: number = -1; 
  listOfForecasts:any;
  constructor(private route: ActivatedRoute,private router:Router,private loaderService: LoaderService,private confirmationService: ConfirmationService,private messageService: MessageService,private _fileService: FileUploadService,private datePipe: DatePipe,private formBuilder: FormBuilder,private financeService:FinanceService, private masterDataService: SponserService,private auditLogService: AuditLogService,private privilegeService: PrivilegeService, private tabAndStateService: TabAndStateService ){
  
    this.forecastForm = this.formBuilder.group({
      //_accrualAmount:['',[Validators.required, Validators.maxLength(15),this.validateNumericField]],
      _forecastedAmount: ['', [Validators.required,Validators.pattern(/^\d{1,13}\.\d{1,2}$|^\d{1,15}$/)]],
      _remarks:['', [Validators.maxLength(300)]],
      _forecastFile: [''], 
      _forecastFileName: '',
      _forecastAttachments: [''],
    });
  }


  attchement:any
  forecastAttachment:any;
  forecastAttachments: ForecastAttachments[]=[];
  auditIdentifierDetails:any;
  auditEntities:any;
  auditOperations:any;
  auditModule:any;
  updatedBy:any;
   ngOnInit() {
    this.BindData(this.forecastId)
    this.auditEntities=AuditLogEntities;
    this.auditOperations=AuditOperations;
    this.auditModule=AuditLogModule;
    this._dateformart=Dateformat;
    this.listOfForecasts=this.tabAndStateService.getForecasetData();
    this.currentIndex = this.listOfForecasts.findIndex((a: { forecastDate: any; }) => a.forecastDate ==this.forecastDetail.forecastDate);

}
BindData(data:any)
{
  this.forecastDetail =data;
    const initialAmount = this.forecastDetail?.forecastedAmount;
  if(data.financeContractForecastAttachments && data.financeContractForecastAttachments.length>0){

         this._contractForecastAttachments.Id = data.financeContractForecastAttachments[0].id;
         this._contractForecastAttachmentsDetails= data.financeContractForecastAttachments;
         this.uploadedFiles = data.financeContractForecastAttachments.map((attachment: { fileName: any; }) => {
           return new File([attachment.fileName], attachment.fileName);
         });
  
       this.uploadedFileNames = this.uploadedFiles.map(file => file.name).join(', ');
         if(this.uploadedFiles.length >= 3)
         {
           this.isUploadButtonDisabled = true;
         }
         else{
           this.isUploadButtonDisabled = false;
         }
       }

  if(this.forecastDetail.id!=0)
    {
        if(this.forecastDetail?.updatedBy==null)
          this.forecastDetail.forecastedAmount=null;
          this.forecastDetail.contractDetailId=this.contractId;
         this.updatedBy=this.privilegeService.getUserName(this.forecastDetail.updatedBy);
    }
    else{
      this.forecastDetail.forecastedAmount=null;
      this.forecastDetail.remarks="";
      this.forecastDetail.contractDetailId=this.contractId;
    }
   
  
   this.auditIdentifierDetails=AuditIdentifier; 
   this.forecastDetailOld=JSON.stringify(this.forecastDetail);

   this.oldContractForecastData=JSON.stringify(this.forecastDetail);
  this.contractForecastDetailBeforeUpdate=JSON.stringify(this.forecastDetail);
}
    
validateNumericField(control: any) {
  const numericRegex = /^\d+(\.\d{1,2})?$/;
  if (control.value && !numericRegex.test(control.value)) {
    return { invalidNumber: true };
  }
  return null;
}

    
    
GetContractForecastDetailById() {
  if(this.forecastDetail.id>0){
    this.financeService.GetContractForecastDetailById(this.forecastDetail.id).subscribe(
      res=>{
        var forecastData=res.data;
      }
    );
  }
};



onCancelContractForecast()
{
if((this.forecastDetailOld==JSON.stringify(this.forecastDetail)))
{
this.cancelForecastButtonClick.emit();
}
else{
this.confirmationService.confirm({
header: 'Confirm',
message: 'Changes will not be saved, Do you want to Continue?',
accept: () => {
this.messageService.add({key: 'tc', severity: 'warn', summary: 'Changes not saved', detail: '',});
this.cancelForecastButtonClick.emit();
}
});
}
}

async saveContractForecast()
{
this.forecastSubmitted=true;
this.isSaveBtnDisable = true;
setTimeout(() => {
  this.isSaveBtnDisable = false;
}, 3000);
if(this.forecastForm.valid)
{
this.loaderService.showLoader();
  if (this.deleteUploadedFiles.length > 0 ) {
   this.deleteAccrualsAttachment();
  }
   if (this.multiAccrualFileData.length > 0) {
  this._fileService.UploadMultipleFile(this.formData).subscribe((response: any) => {
    if (response) {
     this.updateForecastDetails();
    }
    else {
      this.loaderService.hideLoader();
      this.messageService.add({ key: 'tc', severity: 'warn', summary: 'Add Forecast File Failed to save', detail: '' });
    }
  })
}
else {
  this.updateForecastDetails();
}

}
else{
this.messageService.add({  key: 'tc',severity: 'warn', summary: 'Please enter required information', detail: '' });  
}
}

updateForecastDetails(){

this.forecastDetail.forecastDate = this.datePipe.transform(this.forecastDetail.forecastDate, "MM/dd/yyyy");
this.forecastDetail.createdBy = this.privilegeService.getLoginUserId();
 this.forecastDetail.financeContractForecastAttachments = this._contractForecastAttachmentsDetails;

this.financeService.UpdateContractForecast(this.forecastDetail).subscribe(res => {
if(res.status)
{
  

  this.loaderService.hideLoader();
  this.messageService.add({ key: 'tc', severity: 'success', summary: 'Changes have been saved', detail: '' });
  this.compareModels();
  this.saveForecastButtonClick.emit();
       
}
else{
  if (res.message == 'This record is being updated by another user. Please refresh the page.')
       {
      this.messageService.add({
        key: 'tc',
        severity: 'warn',
        summary: res.message,
        detail: ''
      });
    }

  this.loaderService.hideLoader();
}
});

}

onSaveContractAccrual()
{
this.saveForecastButtonClick.emit();
}


maxFileSize:any;
uploadedForecastFileData: any[] = [];
timeStamp:any;
forecastFormData = new FormData();

deleteForecastFile() : any {
var isDeleted=false;
this._fileService.DeleteFile(this.deleteForecastFiles).subscribe(responseDelete=>{
   return isDeleted =responseDelete;
   } 
);
}



deleteForecastFiles : any[]=[]; 

fileDetail:any;

prepareDownload(filename:any, file:any) {

let fileContent= file;
const fileData=new Blob([fileContent], { type:"text/plain"});
const link = document.createElement('a');
link.href = URL.createObjectURL(fileData);
link.download=filename;
link.click();
link.remove();

this.loaderService.hideLoader();
}

changedContractForecastBasicInfo:any;
oldContractForecastData:any;
contractForecastDetailBeforeUpdate:any
compareModels() {
  this.changedContractForecastBasicInfo = this.auditLogService.compareModels(JSON.parse(this.contractForecastDetailBeforeUpdate),this.forecastDetail,this.auditEntities.ContractForecasts,this.auditIdentifierDetails.ContractForecasts,this.auditOperations.Update,this.auditModule.FinanceService);
}
navigateTo(index: number): void {
  if (index >= 0 && index < this.listOfForecasts.length) {
    this.forecastDetail=this.listOfForecasts[index];
    this.BindData(this.forecastDetail);
    this.currentIndex=index;
  }
}
nextRecord(): void {
  this.navigateTo(this.currentIndex + 1);
}
previousRecord(): void {
  this.navigateTo(this.currentIndex - 1);
}
getCurrentPositionText(): string {
  return `${this.currentIndex + 1} of ${this.listOfForecasts.length}`;
}
pageChangeConfirmation(buttonType:number):void{
  if((this.forecastDetailOld==JSON.stringify(this.forecastDetail)))
  {
    buttonType==1?this.nextRecord():this.previousRecord();
  }
  else{
    this.confirmationService.confirm({
      message: 'Changes will not be saved, Do you want to Continue?',
      header: 'Confirmation',
      icon: 'pi pi-exclamation-triangle',
      accept: () => {
        this.messageService.add({
          key: 'tc',
          severity: 'info',
          summary: 'Changes not saved',
          detail: '',
      });
       buttonType==1?this.nextRecord():this.previousRecord();
      },
      reject: () => {
    
      },
    });
  }
}
  currentFileSize: any;
  uploadedFileName: any;
  allowedExtensions: any;
  uploadedForecastFile: any;
  newAttachment: any;
  uploadedFiles: File[] = [];
  _contractForecastAttachmentsDetails: any[] = [];
  uploadedFileNames: string = "";
  isUploadButtonDisabled: boolean = false;
  _contractForecastAttachments = new ContractForecastAttachments();
  multiAccrualFileData: any[] = [];
  formData = new FormData();

  onFileChange(event: any) {
    const files: FileList = event.target.files;
    if (files.length <= 1) {
      this.maxFileSize = this._fileService._fileSize; // 20 MB (value Bytes in binary)
      if (files.length > 0) {
        this.currentFileSize = files[0].size;
        this.uploadedFileName = files[0].name;
        this.allowedExtensions = [FileExtension.DOC, FileExtension.DOCX, FileExtension.PDF, FileExtension.XLS, FileExtension.XLSX, FileExtension.PPT, FileExtension.PPTX];
        var uploadedExtension = this.uploadedFileName.split('.').pop().trim().toLowerCase();
      }
      if (this.allowedExtensions.includes(uploadedExtension)) {
        if (this.currentFileSize <= this.maxFileSize) {
          if (this.uploadedFiles.length + files.length <= 3) {
            for (let i = 0; i < files.length; i++) {
              this.uploadedFiles.push(files[i]);
              this.forecastForm.patchValue({
                _forecastAttachments: files[0].name,
              });
              this.uploadedForecastFile = files[0];
              this.multiAccrualFileData.push(this.uploadedForecastFile);
              this.timeStamp = "";
              var utcDateTimeNow = new Date().toISOString();
              this.timeStamp = formatDate(utcDateTimeNow, this._dateformart.FiletimeStamp, this._dateformart.TimeStampZone);
              //this.formData.append("files[]", file, fileName);
              this.formData.append("file", this.uploadedForecastFile, "/Contracts/Finance/Forecast/" + this.timeStamp + "_" + this.uploadedForecastFile.name);
              this._contractForecastAttachments.FileName = this.uploadedForecastFile.name;
              this._contractForecastAttachments.FilePath = "/Contracts/Finance/Forecast/" + this.timeStamp + "_" + this._contractForecastAttachments.FileName;

              this.newAttachment = {
                FileName: this._contractForecastAttachments.FileName,
                FilePath: this._contractForecastAttachments.FilePath
              };
              this._contractForecastAttachmentsDetails.push(this.newAttachment);
            }
          } else {
            this.forecastForm.patchValue({
              _forecastFileName: '',
              _forecastFile: ''
            });

            this.messageService.add({ key: 'tc', severity: 'error', summary: 'Maximum 3 files allowed.', detail: '' });
          }
        }
        else {
          this.forecastForm.patchValue({
            _forecastFileName: '',
            _forecastFile: ''
          });
          this.messageService.add({ key: 'tc', severity: 'warn', summary: 'File Size limited to 20 Mb', detail: '' });
        }
      }
      else {
        this.forecastForm.patchValue({
          _forecastFileName: '',
          _forecastFile: ''
        });
        this.messageService.add({ key: 'tc', severity: 'error', summary: 'Invalid file type. Only .pdf, .xls, .xlsx, .doc, .docx files are allowed.', detail: '' });
      }

    }
    else {
      this.forecastForm.patchValue({
        _forecastFileName: '',
        _forecastFile: ''
      });
      this.messageService.add({ key: 'tc', severity: 'error', summary: 'Select and upload 1 file at a time.', detail: '' });

    }
    if (this.uploadedFiles.length >= 3) {
      this.isUploadButtonDisabled = true;
    }
    else {
      this.isUploadButtonDisabled = false;
    }
  }
downloadAttachment(data:any)
{
  var attachment = this._contractForecastAttachmentsDetails.find(attachment => attachment.fileName === data.name);

  if (attachment !== null) {
    this.downloadFile(attachment?.fileName, attachment?.filePath);
  }


}


async downloadFile(fileName:any,filePath:any){

var fileDetail = {
  "fileName":fileName,
  "filePath":filePath
};
this._fileService.DownloadFile(fileDetail).subscribe(
  async (res:any)=>{
      var blobData = this._fileService.dataURItoBlob(res);
      if(blobData.size>0){
         var response = await this._fileService.downloadBase64File(blobData,fileDetail.fileName);
         this.loaderService.hideLoader();
      }
      else{
        this.loaderService.hideLoader();
        
      }
  } 
);
}

  deleteUploadedFiles: any[] = [];
  removeFile(file: File) {
    const index = this.uploadedFiles.indexOf(file);
    if (index !== -1) {
      this.uploadedFiles.splice(index, 1);

      const attachmentIndex = this._contractForecastAttachmentsDetails.findIndex(attachment => attachment.FileName === file.name);
      if (attachmentIndex !== -1) {
        this._contractForecastAttachmentsDetails.splice(attachmentIndex, 1);
      }
      this._contractForecastAttachmentsDetails = this._contractForecastAttachmentsDetails.map(e => {
        return this.convertKeysToUppercase(e);
    });
    var isOldAccrualAttachement = this._contractForecastAttachmentsDetails.some(item => item.hasOwnProperty('Id'));
    if(isOldAccrualAttachement){
      const editAccrualAttachment= this._contractForecastAttachmentsDetails.findIndex(s => s.FileName == file.name && s.Id != 0);
      if (editAccrualAttachment !== -1) {    
        var filedetails = {
          "fileName":  this._contractForecastAttachmentsDetails[editAccrualAttachment].FileName,
          "filePath":  this._contractForecastAttachmentsDetails[editAccrualAttachment].FilePath
        };
        if (filedetails.fileName != "" && filedetails.filePath != "") {                    
              this.deleteUploadedFiles.push(filedetails);    
              this._contractForecastAttachmentsDetails.splice(editAccrualAttachment,1)                          
          }
      }   
    }
    else{
      if(this._contractForecastAttachmentsDetails)
      {
        const index = this._contractForecastAttachmentsDetails.findIndex(attachment => attachment.FileName === file.name);
        if (index !== -1) {      
          this._contractForecastAttachmentsDetails.splice(index,1)
      }     
      }
    }

    }
    if(this.uploadedFiles.length >= 3)
    {
      this.isUploadButtonDisabled = true;
    }
    else{
      this.isUploadButtonDisabled = false;
    }
  }
  convertKeysToUppercase(obj: any): any {
    const convertedObject: any = {};
  
    for (const key in obj) {
        if (obj.hasOwnProperty(key)) {
            const uppercaseKey = key.charAt(0).toUpperCase() + key.slice(1);
            convertedObject[uppercaseKey] = obj[key];
        }
    }
  
    return convertedObject;
  }

    deleteAccrualsAttachment(){
    this._fileService.DeleteFile(this.deleteUploadedFiles).subscribe(
      res => {
    
        
      }
    );
    }
}
